import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import ranger from "../../../../assets/info/ranger-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import eziFit from "../../../../assets/info/ford-ranger/ranger-fig-1.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";

const FordRanger = () => {
  useSmallNav("Ford Ranger");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Ford Ranger"} bolder />
        <InfoHero image={ranger} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Do you own and drive a Ford Ranger? Looking for suspension parts or suspension upgrades?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Then you have come to the right place."}
            />
            <p>
              Here at Pedders Suspension we offer a wide range of suspension
              parts including numerous upgraded parts to suit all manner of
              uses.
            </p>
            <p>
              For those carrying heavy loads or towing on a regular basis, we
              are able to offer upgraded rear springs and shocks to cope better
              with the demands of such use. For those operating at the limit of
              the vehicles abilities, these can be supplemented with an air bag
              system. Whatever your usage, we will have a combination of parts
              to do the job.
            </p>
            <p>
              Popular amongst our upgrades are lift kits, be it for serious
              off-roading or just for a more aggressive look, again, we have the
              parts you need.
            </p>
            <p>
              New to our Ranger line up, we now offer the option of Fully
              Assembled Ezifit front struts. Whist we can supply the shocks and
              springs, for many a fully assembled strut offers several
              advantages. These include, no requirement for a spring compressor,
              ALL new components, so no re-use of your old and worn top mounts
              etc, plus of course, speed of fitment. Just undo top and bottom
              mountings, remove old and install new. Done!
            </p>
            <p>
              Looked at our list of Kits and parts, but still not sure what you
              require. Then please get in touch where one of our team will be
              able to assist you.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/0B2KO6qK2fc"
              title={"Ford Mustang Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Ford Mustang Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Ford Mustang Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/xZmjhXhHTAg"
              title={"Ford Mustang Video 4"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5olMu1M-eJ8"
              title={"Ford Mustang Video 5"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Ford")
              .models.find((e) => e.display === "Ranger")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader smaller text={"Pedders EziFit foam strut raised"} />
              <div>
                <StyledImgParts
                  src={eziFit}
                  alt="Pedders EziFit foam strut raised"
                />
              </div>
            </Gray>
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Ford" model="Ranger" /> */}
      </Container>
    </section>
  );
};

export default FordRanger;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
